import { BehaviorSubject } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss']
})
export class SearchListComponent implements OnInit {
  @Input() title = '';

  private _query$ = new BehaviorSubject<string>('');
  public query$ = this._query$.asObservable();

  constructor() { }

  ngOnInit(): void {
  }

  onQueryInput(value: string){
    const v = (value ?? '').trimStart();
    this._query$.next(v);
  }

  clear() {
    this._query$.next('');
  }

}
